import React from "react";
import { useAuth } from "../../contexts/authContext";

export default function Profile() {
  const { currentUser, userData } = useAuth(); // Use userData from AuthContext

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-lg text-gray-600">Please log in to view your profile.</p>
      </div>
    );
  }

  if (!userData) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-lg text-gray-600">Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-2xl p-8 w-full max-w-lg">
        <h2 className="text-2xl font-semibold text-gray-700 mb-6 text-center">
          Profile
        </h2>
        <div className="flex flex-col gap-4">
          <div className="relative">
            <label className="block text-sm font-medium text-gray-500">Full Name</label>
            <input
              className="w-full border border-gray-300 p-3 rounded-lg bg-gray-50 text-gray-700"
              value={userData.fullName || ""}
              readOnly
            />
          </div>

          <div className="relative">
            <label className="block text-sm font-medium text-gray-500">Organization Address</label>
            <input
              className="w-full border border-gray-300 p-3 rounded-lg bg-gray-50 text-gray-700"
              value={userData.organizationAddress || ""}
              readOnly
            />
          </div>

          <div className="relative">
            <label className="block text-sm font-medium text-gray-500">Organization Location</label>
            <input
              className="w-full border border-gray-300 p-3 rounded-lg bg-gray-50 text-gray-700"
              value={userData.organizationLocation || ""}
              readOnly
            />
          </div>

          <div className="relative">
            <label className="block text-sm font-medium text-gray-500">Organization Name</label>
            <input
              className="w-full border border-gray-300 p-3 rounded-lg bg-gray-50 text-gray-700"
              value={userData.organizationName || ""}
              readOnly
            />
          </div>

          <div className="relative">
            <label className="block text-sm font-medium text-gray-500">Phone Number</label>
            <input
              className="w-full border border-gray-300 p-3 rounded-lg bg-gray-50 text-gray-700"
              value={userData.phoneNumber || ""}
              readOnly
            />
          </div>

          <div className="relative">
            <label className="block text-sm font-medium text-gray-500">Work Email</label>
            <input
              className="w-full border border-gray-300 p-3 rounded-lg bg-gray-50 text-gray-700"
              value={userData.workEmail || ""}
              readOnly
            />
          </div>

          <button className="bg-blue-600 hover:bg-blue-700 transition text-white font-semibold p-3 rounded-lg mt-4">
            Update Profile
          </button>
        </div>
      </div>
    </div>
  );
}
